// Search.jsx
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

export function Search(props) {
    const dispatch = useDispatch()
    const [searchTimeout, setSearchTimeout] = useState(false)
    const [searchName, setSearchName] = useState('')

    const searchChangeHandler = (e) => {
        const value = e.target.value

        setSearchName(value)

        if (props.setSearchMainName) {
            props.setSearchMainName(value)
        }

        if (searchTimeout !== false) {
            clearTimeout(searchTimeout)
        }

        if (value !== '') {
            setSearchTimeout(
                setTimeout(
                    (searchValue) => {
                        if (typeof props.search === 'function') {
                            dispatch(props.search(
                                searchValue,
                                props.sortType || 'createdAtMinus',
                                props.sortSearch,
                                props.additionalData
                            ))
                        }
                    },
                    700,
                    value
                )
            )

            return
        }

        if (props.productSort) {
            if (typeof props.getProducts === 'function') {
                dispatch(props.getProducts())
            }

            return
        }

        if (typeof props.get === 'function') {
            dispatch(props.get(
                props.sortType || 'createdAtMinus',
                props.pageNumber || 0,
                props.pageSize || 20,
                undefined,
                props.additionalData
            ))
        }
    }

    return (
        <input
            className="disk__search"
            type="text"
            placeholder="Поиск"
            value={searchName}
            onChange={searchChangeHandler}
        />
    )
}